import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgLocationIconSecondary from './svgs/LocationIconSecondary.js';
import SvgLocationIcon from './svgs/LocationIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var locationIcon = (props => useIcon(SvgLocationIcon, SvgLocationIconSecondary, props));

export { locationIcon as default };
